import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import KofiModal from './KofiModal';
import '../App.css';

const Footer = () => {
  const location = useLocation();
  const [nlEmail, setNlEmail] = useState('');
  const [nlStatus, setNlStatus] = useState(''); // '', 'loading', 'success', 'error'
  const [nlMessage, setNlMessage] = useState('');
  const [kofiOpen, setKofiOpen] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!nlEmail.trim()) return;

    setNlStatus('loading');
    try {
      const resp = await fetch('/api/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: nlEmail.trim() }),
      });
      const result = await resp.json();
      if (resp.ok && result.success) {
        setNlStatus('success');
        setNlMessage("Subscribed. You'll receive updates by email.");
        setNlEmail('');
      } else {
        setNlStatus('error');
        setNlMessage(result.error || 'Something went wrong.');
      }
    } catch {
      setNlStatus('error');
      setNlMessage('Could not connect. Try again.');
    }
  };

  return (
    <>
      <footer style={{ width: '100%', marginTop: '2rem' }}>
        <div className="footer-container">

          {/* Newsletter signup — inline */}
          <div style={{ marginBottom: 0 }}>
            {nlStatus === 'success' ? (
              <p className="footer-nl-msg success">{nlMessage}</p>
            ) : (
              <form onSubmit={handleNewsletterSubmit} className="footer-nl">
                <label className="footer-nl-label" htmlFor="footer-nl-email">
                  ✉ Stay updated by email
                </label>
                <input
                  id="footer-nl-email"
                  type="email"
                  value={nlEmail}
                  onChange={(e) => setNlEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  maxLength={254}
                  className="footer-nl-input"
                  disabled={nlStatus === 'loading'}
                />
                <button
                  type="submit"
                  className="footer-nl-btn"
                  disabled={nlStatus === 'loading'}
                >
                  {nlStatus === 'loading' ? '...' : 'Sign up'}
                </button>
                {nlStatus === 'error' && (
                  <p className="footer-nl-msg error">{nlMessage}</p>
                )}
              </form>
            )}
          </div>

          {/* Footer links */}
          <ul className="mobile:hidden flex flex-row justify-end gap-5 text-sm" style={{ padding: 0, margin: 0 }}>
            <li className="whitespace-nowrap" style={{ listStyle: 'none' }}>
              <a
                href="#support"
                onClick={(e) => { e.preventDefault(); setKofiOpen(true); }}
                className="hover:underline"
              >
                Support us
              </a>
            </li>

            <li style={{ listStyle: 'none' }}>
              <a href="/contact" className="hover:underline">
                Contact
              </a>
            </li>

            <li style={{ listStyle: 'none' }}>
              <a href="https://www.instagram.com/hasbaratracker/" target="_blank" rel="noreferrer" className="hover:underline">
                Instagram
              </a>
            </li>

            <li style={{ listStyle: 'none' }}>
              <a href="https://x.com/hasbaratracker" target="_blank" rel="noreferrer" className="hover:underline">
                X
              </a>
            </li>
          </ul>

        </div>
      </footer>

      <KofiModal isOpen={kofiOpen} onClose={() => setKofiOpen(false)} />
    </>
  );
};

export default Footer;
